module.exports = __webpack_public_path__ + "static/media/RM.26126d5a.webp";